import React from 'react';
import styles from './mysaves.module.css'

const MySaves=()=>{
    return(
        <div className={styles.con}>
            <div className={styles.header}>
                <h2>Save</h2>
            </div>
            <div className={styles.todaysec}>
                
                <div className={styles.date}>Today</div>
            <div className={styles.mediaCon}>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
               
               
                </div>             
            
            </div>
            <div className={styles.todaysec}>
                
                <div className={styles.date}>Yesterday</div>
            <div className={styles.mediaCon}>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
               
               
                </div>            
                <div className={styles.todaysec}>
                
                <div className={styles.date}>2<sup>nd</sup> Feb 2020</div></div>
            <div className={styles.mediaCon}>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
                <img src="https://vsam.me/userimages/28-29-12-20-10-27-54-29-12-20.png"/>
               
               
                </div>            
            
            </div>


            
        </div>
    )
}


export default MySaves